module.exports = __webpack_public_path__ + "static/biancaWallpaper-10ca57451a33a696548b848b5e16c247.jpg";